import React, { useState } from 'react';
import EndpointComponent from './EndpointComponent';
import StatusDescriptionsSection from './StatusDescriptionsSection';

const ApiSection = ({ apiCategory }) => {
    const { title, description, endpoints } = apiCategory;
    const [expandedEndpoint, setExpandedEndpoint] = useState(null);
    const [isStatusExpanded, setIsStatusExpanded] = useState(false);

    const toggleEndpoint = (index) => {
        if (expandedEndpoint === index) {
            setExpandedEndpoint(null);
        } else {
            setExpandedEndpoint(index);
        }
    };

    // 检查是否是翻译相关的API分类
    const isTranslationCategory = title === "翻译任务";

    return (
        <div className="flex flex-col gap-8 py-2">
            {/* <h2 className="text-3xl font-semibold mb-4 text-gray-800 pb-2 border-b-2 border-gray-100">{title}</h2> */}
            <p className="leading-relaxed">{description}</p>

            <div className="border border-gray-200 rounded-lg overflow-hidden">
                {endpoints.map((endpoint, index) => (
                    <div key={index} className={`border-b border-gray-200 ${index === endpoints.length - 1 && !isTranslationCategory ? 'border-b-0' : ''}`}>
                        <div
                            className="flex items-center px-4 py-4 cursor-pointer gap-2 justify-between flex-wrap bg-gray-50 hover:bg-gray-100 transition-colors"
                            onClick={() => toggleEndpoint(index)}
                        >
                            <div className="flex items-center">
                                <div className={`px-3 py-1.5 rounded text-xs uppercase ${endpoint.method.toLowerCase() === 'get' ? 'bg-[--blue-5]' :
                                    endpoint.method.toLowerCase() === 'post' ? 'bg-[--grass-5]' :
                                        endpoint.method.toLowerCase() === 'put' ? 'bg-[--yellow-5]' :
                                            endpoint.method.toLowerCase() === 'delete' ? 'bg-[--tomato-5]' : 'bg-gray-500'
                                    }`}>
                                    {endpoint.method}
                                </div>
                                <span className="flex-1 font-mono mx-4 text-gray-700 text-[15px]">{endpoint.path}</span>
                            </div>
                            <div className="flex items-center">
                                <span className="text-gray-600 mr-4">{endpoint.name}</span>
                                <span className={`transition-transform duration-300 ${expandedEndpoint === index ? 'transform rotate-180' : ''}`}>
                                    <i className="bx bx-chevron-down"></i>
                                </span>
                            </div>
                        </div>

                        {expandedEndpoint === index && (
                            <div className="p-6 bg-white border-t border-gray-200">
                                <EndpointComponent endpoint={endpoint} />
                            </div>
                        )}
                    </div>
                ))}
                
                {/* 对于翻译任务分类，显示状态描述部分，与endpoints同级 */}
                {isTranslationCategory && (
                    <div className="border-b-0">
                        <div
                            className="flex items-center px-4 py-4 cursor-pointer gap-2 justify-between flex-wrap bg-gray-50 hover:bg-gray-100 transition-colors"
                            onClick={() => setIsStatusExpanded(!isStatusExpanded)}
                        >
                            <div className="flex items-center">
                                <div className="px-3 py-1.5 rounded text-xs uppercase bg-[--mauve-5]">
                                    状态
                                </div>
                                 <span className="text-gray-600 mx-4 ">翻译任务状态说明</span>
                            </div>
                            <div className="flex items-center">
                               
                                <span className={`transition-transform duration-300 ${isStatusExpanded ? 'transform rotate-180' : ''}`}>
                                    <i className="bx bx-chevron-down"></i>
                                </span>
                            </div>
                        </div>

                        {isStatusExpanded && (
                            <div className="p-6 bg-white border-t border-gray-200">
                                <StatusDescriptionsSection />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ApiSection; 